import { render, staticRenderFns } from "./personalWalletModal.vue?vue&type=template&id=2a883486"
import script from "./personalWalletModal.vue?vue&type=script&lang=js"
export * from "./personalWalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports